import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["column", "list", "card"]

  connect() {
    this.draggedCard = null
    this.placeholder = null

    this.cardTargets.forEach(card => {
      card.setAttribute("draggable", "true")
      card.addEventListener("dragstart", this.onDragStart.bind(this))
      card.addEventListener("dragend", this.onDragEnd.bind(this))
    })

    this.listTargets.forEach(list => {
      list.addEventListener("dragover", this.onDragOver.bind(this))
      list.addEventListener("drop", this.onDrop.bind(this))
    })
  }

  onDragStart(event) {
    this.draggedCard = event.currentTarget
    this.draggedCard.classList.add("opacity-50", "rotate-2")
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", this.draggedCard.dataset.taskId)

    this.placeholder = document.createElement("div")
    this.placeholder.classList.add(
      "border-2", "border-dashed", "border-mod-warm-400",
      "bg-mod-warm-50", "rounded-lg", "h-20", "transition-all"
    )
  }

  onDragEnd() {
    if (this.draggedCard) {
      this.draggedCard.classList.remove("opacity-50", "rotate-2")
    }
    if (this.placeholder && this.placeholder.parentNode) {
      this.placeholder.remove()
    }
    this.draggedCard = null
    this.placeholder = null
  }

  onDragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const list = event.currentTarget
    if (!this.placeholder.parentNode || this.placeholder.parentNode !== list) {
      list.appendChild(this.placeholder)
    }
  }

  onDrop(event) {
    event.preventDefault()
    const taskId = event.dataTransfer.getData("text/plain")
    const list = event.currentTarget
    const column = list.closest("[data-task-board-target='column']")
    if (!column) return

    const newStatus = column.dataset.status
    const card = this.element.querySelector(`[data-task-id='${taskId}']`)

    if (card && list) {
      if (this.placeholder && this.placeholder.parentNode) {
        this.placeholder.replaceWith(card)
      } else {
        list.appendChild(card)
      }
      this.updateTaskStatus(taskId, newStatus)
      this.updateColumnCounts()
    }
  }

  async updateTaskStatus(taskId, status) {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    try {
      await fetch(`/tasks/${taskId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ task: { status: status } })
      })
    } catch (error) {
      console.error("Failed to update task status:", error)
    }
  }

  updateColumnCounts() {
    this.columnTargets.forEach(column => {
      const count = column.querySelectorAll("[data-task-id]").length
      const badge = column.querySelector("[data-count]")
      if (badge) badge.textContent = count
    })
  }
}
